import {cn} from '@/lib/utils'

const tones = {
  green: 'bg-accent text-accent-foreground',
  neutral: 'bg-secondary text-muted-foreground',
  ink: 'bg-ink text-background',
  inverse: 'bg-white/10 text-white/80',
  red: 'tone-red',
  orange: 'tone-orange',
  amber: 'tone-amber',
  lime: 'tone-lime',
  // E10 D9: estado semántico, no decoración.
  enCurso: 'tone-en-curso',
} as const

export function Tag({
  tone = 'neutral',
  className,
  ...props
}: React.ComponentProps<'span'> & {tone?: keyof typeof tones}) {
  return (
    <span
      className={cn(
        // Como flex-item, sin `min-w-0` el chip no se achica hasta `max-w-full`; `break-words` y no
        // truncate porque hay chips que deben partirse antes que perder una fecha.
        'inline-flex max-w-full min-w-0 items-center rounded-[3px] px-1.5 py-[3px] font-mono text-[10px] leading-none font-semibold tracking-wider break-words uppercase',
        tones[tone],
        className
      )}
      {...props}
    />
  )
}
